import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Select from 'react-select';
import { API_URL } from "..";
import { Icon } from "@iconify/react/dist/iconify.js";

const GeneratePayroll = () => {
  const [showAlertMessage, setShowAlertMessage] = useState({
    status: false,
    message: '',
    desc: ''
  });
  const [payrollType, setPayrollType] = useState('all');
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [employeeOptions, setEmployeeOptions] = useState([]);

  const monthOptions = [
    { value: '01', label: 'January' },
    { value: '02', label: 'February' },
    { value: '03', label: 'March' },
    { value: '04', label: 'April' },
    { value: '05', label: 'May' },
    { value: '06', label: 'June' },
    { value: '07', label: 'July' },
    { value: '08', label: 'August' },
    { value: '09', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' },
  ];

  const yearOptions = Array.from({ length: 31 }, (_, i) => ({
    value: (2000 + i).toString(),
    label: (2000 + i).toString()
  }));

  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
      Accept: "*/*",
    };

    try {
      const response = await fetch(`${API_URL}/api/driver/fetch/${user.id}`, {
        headers: headersList,
        method: 'GET'
      });
      const data = await response.json();
      const formattedData = data.data.map((e) => ({
        value: e.id,
        label: e.first_name + ' ' + e.last_name
      }));
      setEmployeeOptions(formattedData);
    } catch (error) {
      console.error(error.message);
    }
  };

  const handlePayrollTypeChange = (type) => {
    setPayrollType(type);
    if (type === 'all') {
      setSelectedEmployees([]);
    }
  };

  const handleEmployeeChange = (selected) => {
    setSelectedEmployees(selected || []);
  };

  const handleMonthChange = (selected) => {
    setSelectedMonth(selected);
  };

  const handleYearChange = (selected) => {
    setSelectedYear(selected);
  };

  const onFormSubmit = async (event) => {
    event.preventDefault();
    
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
      "Accept": "*/*",
      "Content-Type": "application/json"
    };

    let bodyContent = JSON.stringify({
      org_id: user.id,
      month: selectedMonth?.value,
      year: selectedYear?.value,
      type: payrollType,
      emp_ids: payrollType === 'individual' ? selectedEmployees.map(emp => emp.value) : []
    });

    try {
      let response = await fetch(`${API_URL}/api/payroll/generate`, {
        method: "POST",
        body: bodyContent,
        headers: headersList
      });

      let data = await response.json();
      if (response.status === 201) {
        setShowAlertMessage({
          message: 'success',
          status: true,
          desc: 'Payroll generated successfully'
        });
        setSelectedEmployees([]);
        setSelectedMonth(null);
        setSelectedYear(null);
      } else {
        setShowAlertMessage({
          message: 'error',
          status: true,
          desc: 'Error while generating payroll'
        });
      }
    } catch (error) {
      setShowAlertMessage({
        message: 'error',
        status: true,
        desc: 'Network error while generating payroll'
      });
    }
  };

  return (
    <MasterLayout>
      <Breadcrumb title="Generate Payroll" />
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8 col-lg-10">
              <div className="border">
                <div className="card-body">
                  <form onSubmit={onFormSubmit}>
                    <div className="mb-20">
                      <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                        Payroll Type <span className="text-danger-600">*</span>
                      </label>
                      <div className="form-check checked-success d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="payroll_type"
                          id="radioAll"
                          value="all"
                          checked={payrollType === 'all'}
                          onChange={() => handlePayrollTypeChange('all')}
                        />
                        <label className="form-check-label line-height-1 fw-medium text-secondary-light" htmlFor="radioAll">
                          All
                        </label>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="payroll_type"
                          id="radioIndividual"
                          value="individual"
                          checked={payrollType === 'individual'}
                          onChange={() => handlePayrollTypeChange('individual')}
                        />
                        <label className="form-check-label line-height-1 fw-medium text-secondary-light" htmlFor="radioIndividual">
                          Individual
                        </label>
                      </div>
                    </div>

                    {payrollType === 'individual' && (
                      <div className="mb-20">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Select Employees <span className="text-danger-600">*</span>
                        </label>
                        <Select
                          isMulti
                          options={employeeOptions}
                          value={selectedEmployees}
                          onChange={handleEmployeeChange}
                          placeholder="Select Employees"
                        />
                      </div>
                    )}

                    <div className="row mb-20">
                      <div className="col-md-6">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Select Month <span className="text-danger-600">*</span>
                        </label>
                        <Select
                          options={monthOptions}
                          value={selectedMonth}
                          onChange={handleMonthChange}
                          placeholder="Select Month"
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                          Select Year <span className="text-danger-600">*</span>
                        </label>
                        <Select
                          options={yearOptions}
                          value={selectedYear}
                          onChange={handleYearChange}
                          placeholder="Select Year"
                        />
                      </div>
                    </div>

                    {showAlertMessage.status && (
                      <div
                        className={
                          showAlertMessage.message === 'error'
                            ? "alert alert-danger bg-danger-50 text-danger-600 border-danger-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                            : "alert alert-success bg-success-50 text-success-600 border-success-50 px-24 py-11 mb-0 fw-semibold text-lg radius-8 d-flex align-items-center justify-content-between mb-10"
                        }
                        role="alert"
                      >
                        {showAlertMessage.desc}
                        <button
                          type="button"
                          onClick={() => setShowAlertMessage({ status: false, message: '', desc: '' })}
                          className="remove-button text-secondary-600 text-xxl line-height-1"
                        >
                          <Icon icon="iconamoon:sign-times-light" className="icon" />
                        </button>
                      </div>
                    )}

                    <div className="d-flex align-items-end justify-content-center mt-20 gap-3">
                      <button
                        type="submit"
                        className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      >
                        Generate Payroll
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default GeneratePayroll;